// @ts-nocheck
import emailjs from "@emailjs/browser";

const EMAIL_JS_SERVICE_ID = process.env.REACT_APP_EMAIL_JS_SERVICE_ID;
const EMAIL_JS_TEMPLATE_ID_NOTIFICATION = process.env.REACT_APP_EMAIL_JS_TEMPLATE_ID_NOTIFICATION;
const EMAIL_JS_PUBLIC_KEY = process.env.REACT_APP_EMAIL_JS_PUBLIC_KEY;
export const sendNotificationEmail = (
  receiverEmail: string,
  email: string,
  fromName: string,
  message: string,
) => {
  emailjs
    .send(
      EMAIL_JS_SERVICE_ID as string,
      EMAIL_JS_TEMPLATE_ID_NOTIFICATION as string,
      {
        to_email: receiverEmail,
        from_email: email,
        from_name: fromName,
        message,
      },
      EMAIL_JS_PUBLIC_KEY
    )
    .then(
      () => {},
      (error:any) => {
        alert(error.text);
      }
    );
};